import { render, staticRenderFns } from "./TransmitterEdit.vue?vue&type=template&id=588cc275&scoped=true"
import script from "./TransmitterEdit.vue?vue&type=script&lang=js"
export * from "./TransmitterEdit.vue?vue&type=script&lang=js"
import style0 from "./TransmitterEdit.vue?vue&type=style&index=0&id=588cc275&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588cc275",
  null
  
)

export default component.exports